<script setup lang="ts">
defineProps<{
  text: string;
  isPulsing: boolean;
  isError?: boolean;
}>();
</script>

<template>
  <div
    class="relative flex items-center gap-1 self-start rounded-full border px-1.5 py-0.5 text-xs font-medium select-none"
    :class="
      isPulsing
        ? 'border-success-base text-success-base'
        : isError
          ? 'border-warning-base text-warning-base'
          : 'border-md text-lt'
    ">
    <template v-if="isPulsing">
      <div class="size-3 animate-pulse rounded-full bg-success-base/50" />
      <div class="absolute top-2 left-2.5 size-1 rounded-full bg-success-base" />
    </template>
    <div v-else class="size-2.5 rounded-full" :class="isError ? 'bg-warning-base' : 'bg-hvy'" />
    {{ text }}
  </div>
</template>
